import { render, staticRenderFns } from "./zhuanti-shuzijingji.vue?vue&type=template&id=243cdebc&"
import script from "./zhuanti-shuzijingji.vue?vue&type=script&lang=js&"
export * from "./zhuanti-shuzijingji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports